<template>
  <div >
       <div class="dx-field" style="float:none;"> 
        <div class="dx-field-value" style="float:none;width:auto;">
          <DxDropDownButton style="color:#fff;"
            :items="dataType"
            :drop-down-options="{ width: 230 }"
            text="Document Type"
            display-expr="name"
            icon="docfile"
            @item-click="itemClick"
          />
        </div>
      </div>
  <div style="color:#fff;">
  <h1 >{{this.docType}} <button @click="addDocumentClick">+ Add {{docName}}</button> <button @click="exportData">Export Data</button> <button @click="migrateData">Migrate Data</button></h1>
   </div>
   <div class="docList">
    
  <EditableDocument v-for="(wrecks,i) in documents" :key="'wrecks'+i" class="blackBG alignLeft" style="padding-left:10px;flex-direction: row;" :collection="docType" :textID="i">
    
   </EditableDocument> 
 </div>
  </div>
</template>

<script>
import { saveAs } from 'file-saver';
import { jsonFormat } from 'json-format';
import EditableDocument from '../components/EditableDocument'
import { DxDropDownButton, DxToolbar } from 'devextreme-vue';
import notify from 'devextreme/ui/notify';
import 'whatwg-fetch';
export default {
  components: {
    EditableDocument,
    DxDropDownButton,
    DxToolbar
  },
  props:{index:{default:0}},
  data() {
    return {
      docType:"Documents",
      docName:"Document",
      dataType:[ {type:'Wrecks',name:'Wreck'},{type:'Documents',name:'Document'},{type:'Experts',name:'Expert'},{type:'Evidence',name:'Evidence'},{type:'Maps',name:'Map'},{type:'Locations',name:'Location'}, {type:'Actions',name:'Action'},{type:'Artefacts',name:'Artefacts'}, {type:'Help',name:'Help'} ]
    }
  },
  mounted(){
     this.docType=this.dataType[this.index].type
     this.docName=this.dataType[this.index].name
     this.$store.dispatch('loadText',this.docType)
    },
    computed:{
      documents(){
        if( this.loaded || true ){
           let data=this.$store.getters.getLoadedText(this.docType)
           console.log("DATA",data)
          
            if(data){
              console.log("SORT DATA",this.sortObject(data))
               
              return this.sortObject(data)

            }
            
        }
      },
      loadingText(){
        return this.$store.getters.loadingText
      },
    },
    methods:{
      migrateData(){
        this.$store.dispatch("migrate",{name:this.docName,data:this.documents})
      },
      exportData(){
        var FileSaver = require('file-saver');
         var jsonFormat = require('json-format');
       // console.log(JSON.stringify(this.documents))
         console.log(jsonFormat(this.documents))
               var blob = new Blob([jsonFormat(this.documents)], {type: "text/plain;charset=utf-8"});
               FileSaver.saveAs(blob, this.docName+".json");
      },
      sortObject(obj){
          let newObj={}
          let keys=Object.keys(obj)
          keys=keys.sort(compare)
          for(var k in keys){
            newObj[keys[k]]=obj[keys[k]]
          }
          return newObj
          function compare(a, b) {
            if (a.type < b.type || a.type=="Name")
              return -1;
            if (a.type > b.type &&  b.type!="Name")
              return 1;
            return 0;
          }
      },
      itemClick(e){
      this.docType=e.itemData.type
      this.docName=e.itemData.name
      this.$store.dispatch('loadText',this.docType)
      },
      addDocumentClick(){
      this.$store.commit('setShowPopup',{
        title:"Add "+this.docName,
        input:"Enter Field Name",
        btns:[{label:"cancel"},{label:"add",action:this.addDocument}]
        })
      },
      addDocument(param){
        console.log(this.documents[Object.keys(this.documents)[0]])
        let baseObj=this.documents[Object.keys(this.documents)[0]]
        let keys=Object.keys(baseObj)
        let obj={}

        for(var prop in keys ){
          console.log(keys[prop])
          obj[keys[prop]]="-------"
        }
        this.$store.dispatch("addDocument",{collection:this.docType,doc:param,content:obj})
        
        //this.$store.dispatch("addDocument",{collection:this.docType,doc:param,field:"name",content:"Enter Text"})
      },
     saveHelp(html){
       this.$store.dispatch("saveSpecificText",{type:"Playing",content:html})
     }
    },
    watch:{
      
      
    },
  beforeDestroy() {
    
  },
}
</script>
<style>

.blackBG{
  color:#fff;
  background-color: #000;
}
.whiteBG{
  color:#000;
  background-color: #fff;
}
.alignLeft{
  text-align: left;
}
.padSide{
  padding-left: 50px;
  padding-right: 50px;
}

</style>